import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { PersistentActions } from '../actions/PersistentActions';
import { PersistentStore } from '../stores/PersistentStore';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';

export class SelectionSidebarOrientation extends SelectionBase {
    protected id: string = 'sidebarposition-select';

    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: PersistentStore.getState().sidebarPosition,
            visible: AppConfigurationStore.getState().sidebarMoveable,
            enabled: true
        });
    };

    protected getLabel(): string {
        return t('Taskbar Position');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {name: t('Left'), className: 'egr-select-option-noicon', key: 'left', callback: PersistentActions.setLeftSidebarPosition},
            {name: t('Right'), className: 'egr-select-option-noicon', key: 'right', callback: PersistentActions.setRightSidebarPosition}
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionSidebarOrientation.tsx